export class ReferenceData {
  constructor(referenceData: any) {
    if (referenceData) {
      this.Code = referenceData.ID ? referenceData.ID : referenceData.Code;
      this.Value = referenceData.Value;
      this.SortOrder = referenceData.SortOrder;
      this.Attributes = referenceData.Attributes;
    }
  }

  public Code: string;
  public Value: string;
  public SortOrder: string;
  public Attributes: Array<any>;

  public getAttributeValue(attributeName: string): string {
    const result =
      this.Attributes && this.Attributes.length > 0
        ? this.Attributes.find((a) => a.Name === attributeName.toLocaleLowerCase())
        : undefined;

    return result && result.Values.length > 0 ? result.Values[0] : '';
  }
}
